(() => {
  const thresholdDefault = 5000;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  let timer = null;
  let inFlight = false;

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "it-IT", {
        style: "currency",
        currency: currency || "EUR"
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return "€" + ((Number(cents) || 0) / 100).toFixed(2).replace(".", ",");
    }
  }

  function paint(cart) {
    const total = Number(cart && cart.total_price) || 0;
    document.querySelectorAll("[data-bulligans-shipping-progress]").forEach((widget) => {
      const threshold = Number(widget.dataset.threshold) || thresholdDefault;
      const remaining = Math.max(threshold - total, 0);
      const ratio = Math.max(0, Math.min(100, (total / threshold) * 100));
      widget.dataset.cartTotal = String(total);

      const message = widget.querySelector("[data-bulligans-shipping-message]");
      if (message) {
        if (remaining <= 0) {
          const strong = document.createElement("strong");
          strong.textContent = "Hai raggiunto la soglia per la spedizione gratuita!";
          message.replaceChildren(strong);
        } else {
          const lead = document.createTextNode("Ti mancano ");
          const amount = document.createElement("strong");
          amount.textContent = formatMoney(remaining, cart.currency);
          const tail = document.createTextNode(" per ottenere la spedizione gratuita.");
          message.replaceChildren(lead, amount, tail);
        }
      }

      const fill = widget.querySelector("[data-bulligans-shipping-fill]");
      if (fill) fill.style.width = ratio.toFixed(2) + "%";
      const bar = widget.querySelector('[role="progressbar"]');
      if (bar) bar.setAttribute("aria-valuenow", String(Math.min(total, threshold)));
      widget.classList.toggle("is-complete", remaining <= 0);
    });
  }

  async function refresh() {
    if (inFlight) return;
    inFlight = true;
    try {
      const prefix = root.endsWith("/") ? root : root + "/";
      const response = await fetch(prefix + "cart.js", {
        credentials: "same-origin",
        headers: { "Accept": "application/json" },
        cache: "no-store"
      });
      if (response.ok) paint(await response.json());
    } catch (_) {
      // Keep the Liquid-rendered amount if the cart endpoint is temporarily unavailable.
    } finally {
      inFlight = false;
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(timer);
    timer = window.setTimeout(refresh, 180);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh, { once: true });
  } else {
    refresh();
  }

  ["cart:updated", "cart:update", "cart:change", "shopify:section:load"].forEach((eventName) => {
    document.addEventListener(eventName, scheduleRefresh);
  });

  const relevantAreas = "#cart-notification, cart-drawer, #main-cart-footer, #main-cart-items";
  const observer = new MutationObserver((mutations) => {
    const relevantChange = mutations.some((mutation) => {
      const target = mutation.target && (mutation.target.nodeType === 1
        ? mutation.target
        : mutation.target.parentElement);
      if (!target || target.closest("[data-bulligans-shipping-progress]")) return false;
      return !!target.closest(relevantAreas);
    });
    if (relevantChange) scheduleRefresh();
  });
  if (document.body) observer.observe(document.body, { subtree: true, childList: true, characterData: true });
})();